import { z } from 'zod';
import { ValidationRules } from './validation-rules';

// Login form schema
export const loginSchema = z.object({
  username: ValidationRules.username,
});

// Type inference from schema
export type LoginFormData = z.infer<typeof loginSchema>;

// Default values
export const loginFormDefaults: LoginFormData = {
  username: '',
};
